import { render, staticRenderFns } from "./SalesLegalReport.vue?vue&type=template&id=4a340c06"
import script from "./SalesLegalReport.vue?vue&type=script&lang=js"
export * from "./SalesLegalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports